const Odometer = require("odometer");

const statistisGridClass = ".statistics-grid";

function createStatisticsGrids() {
  function init() {
    document.addEventListener('DOMContentLoaded', () => {
      document.querySelectorAll(statistisGridClass).forEach((grid) => {
        createSingleStatisticsGrid(grid);
      });
    });
  }

  return { init };
}

function createSingleStatisticsGrid(grid) {
  const stats = Array.from(
    grid.querySelectorAll(`${statistisGridClass}__stat`)
  ).map((stat) => {
    const number = stat.querySelector(`${statistisGridClass}__stat--number`);
    const odo = new Odometer({
      el: number,
      format: "(,ddd)",
    });

    return {
      container: stat,
      odometer: odo,
    };
  });

  const statsObserverConfig = {
    rootMargin: "0px",
    threshold: 1,
  };

  const statsObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const statObject = stats.find(
          (stat) => stat.container === entry.target
        );

        if (statObject) {
          statObject.odometer.update(entry.target.dataset.stat);
        }
      }
    });
  }, statsObserverConfig);

  stats.forEach((stat) => {
    statsObserver.observe(stat.container);
  });
}

const statistisGrids = createStatisticsGrids();
statistisGrids.init();
